import DiscordIcon from "@/components/logos/DiscordIcon";
import TelegramLogo from "@/components/logos/TelegramIcon";
import GoogleIcon from "@/components/logos/GoogleIcon";

export enum AuthProvider {
  TELEGRAM = "telegram",
  GOOGLE = "google",
  DISCORD = "discord",
}

const whiteListedProviders = [AuthProvider.DISCORD];

const PROVIDER_ICONS = {
  [AuthProvider.TELEGRAM]: TelegramLogo,
  [AuthProvider.GOOGLE]: GoogleIcon,
  [AuthProvider.DISCORD]: DiscordIcon,
} as const;

export const getProviderIcon = (provider: AuthProvider | undefined) => {
  if (!provider || !(provider in PROVIDER_ICONS)) {
    return GoogleIcon;
  }
  return PROVIDER_ICONS[provider as keyof typeof PROVIDER_ICONS];
};

export const doesProviderNeedPinConfirmation = (provider: AuthProvider) => {
  return !whiteListedProviders.includes(provider);
};
